import type { Component } from "../types/platform";

export const components: readonly Component[] = [
  {
    name: "Atlas",
    tagline: "Semantic search and discovery.",
    why: "60,000 courses only help if the right one can be found. Keyword search misses courses that teach the skill under another name or in another language. Plan and Marketplace need to find training by what it teaches, not what it's called.",
    description:
      "Cross-lingual semantic search and recommendation across the catalog. No UI of its own; it surfaces inside Marketplace and ILS and is callable by Coach.",
    how: "Hybrid retrieval, dense plus lexical, with RRF fusion and cross-encoder reranking. Exposed through REST, MCP, and A2A.",
    consumedBy: ["Marketplace", "ILS", "Coach"],
    accessVia: ["REST API", "MCP", "A2A"],
    agentPartner: "Plan",
    surfaceUrl: "https://marketplace.opensesame.art"
  },
  {
    name: "Skyfall",
    tagline: "Headless delivery and tracking.",
    why: "Training has to play wherever a customer already runs it, and every play has to be counted. Licensing, royalties, and the learner record all start there.",
    description:
      "Plays courses through SCORM 1.2 / 2004 and LTI 1.3 and reports every event. Sesame Seed wraps content for customer LMSs and enforces entitlement.",
    how: "Rust/Axum delivery engine with sub-100ms playback and full event telemetry. Exposed through REST and MCP.",
    consumedBy: ["ILS", "ECP", "Ops"],
    accessVia: ["REST API", "MCP"],
    agentPartner: "Deliver"
  },
  {
    name: "Enigma",
    tagline: "Content intelligence.",
    why: "A course package is a black box. Search, recommendation, and assessment all need to know what a course teaches and tests, and that is locked inside compiled SCORM, AICC, and xAPI files.",
    description:
      "Takes course packages apart into structured knowledge: objectives, topics, assessments, skills.",
    how: "Two-pass pipeline, deterministic extraction then AI enrichment, with per-package cost accounting. Exposed through REST, MCP, and A2A.",
    consumedBy: ["ILS", "Marketplace", "Coach"],
    accessVia: ["REST API", "MCP", "A2A"],
    agentPartner: "Decode"
  },
  {
    name: "Conduit",
    tagline: "HRIS broker.",
    why: "Everything downstream depends on knowing who the workers are and what roles they hold. That data lives in each customer's HRIS, in a different shape every time, and it is sensitive.",
    description:
      "Multi-tenant HRIS broker and the source of truth for employment data feeding ILS, Proof, CSR, and Ops.",
    how: "Field-level AES-256-GCM encryption, blind indexes, and tenant-isolated keys. Exposed through REST, MCP, and A2A.",
    consumedBy: ["ILS", "CSR", "Ops", "Proof"],
    accessVia: ["REST API", "MCP", "A2A"],
    agentPartner: "Connect"
  }
] as const;
